import type {ColorTokenGroup} from './types';

export const theme = {
  tsx: {
    grey: <ColorTokenGroup>{
      5: '#f5f7f7',
      10: '#f0f2f2',
      20: '#e3e7e8',
      30: '#d0d7d9',
      40: '#b2bdbf',
      50: '#919c9e',
      60: '#6d7678',
      70: '#515859',
      80: '#3c4142',
      90: '#2b3030',
      100: '#222626',
    },

    accent: <ColorTokenGroup>{
      5: '#f0fcf2',
      10: '#e1f7e4',
      20: '#c5e8ca',
      30: '#99cea0',
      40: '#72c07d',
      50: '#55b465',
      60: '#32a94b',
      70: '#2a9b43',
      80: '#1e8737',
      90: '#0e762c',
      100: '#00591d',
    },
  },

  ts5: {
    grey: <ColorTokenGroup>{
      5: '#f5f7f7',
      10: '#f0f2f2',
      20: '#e3e7e8',
      30: '#d0d6d9',
      40: '#b2bbbf',
      50: '#919a9e',
      60: '#6d7578',
      70: '#515759',
      80: '#3c4042',
      90: '#2b2f30',
      100: '#222526',
    },

    accent: <ColorTokenGroup>{
      5: '#f0fdf3',
      10: '#e1fae6',
      20: '#c3ebca',
      30: '#98daa5',
      40: '#6dcb81',
      50: '#4dc069',
      60: '#20b44f',
      70: '#15a546',
      80: '#00923a',
      90: '#00812f',
      100: '#00631f',
    },
  },

  x5: {
    grey: <ColorTokenGroup>{
      5: '#f5f7f7',
      10: '#f0f2f2',
      20: '#e3e8e8',
      30: '#d0d9d9',
      40: '#b2bfbf',
      50: '#919e9e',
      60: '#6d7878',
      70: '#515959',
      80: '#3c4242',
      90: '#2b3030',
      100: '#222626',
    },

    accent: <ColorTokenGroup>{
      5: '#f5fcf0',
      10: '#ebfae1',
      20: '#d0f0bb',
      30: '#b0dd92',
      40: '#97d26d',
      50: '#84c950',
      60: '#6fc031',
      70: '#5faf2d',
      80: '#4e9c1f',
      90: '#3a8918',
      100: '#0d6706',
    },
  },
} as const;
